import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Department Name',
    field: 'departmentName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Manager Name',
    field: 'managerName',
    filter: 'text',
    searchable: true,
  },
];
